import { Link } from "react-router-dom";
const Main = () => {
  return (
    <>
      <div className="main-page">
        <div className="flex-block">
          <div>
            <Link to="/HomeFr">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/farrukabad-logo.png" />
              <button>
                ARRAH PAHARPUR website <i class="bi bi-caret-right-fill"></i>
              </button>
            </Link>
          </div>
          <div>
            <Link to="/Home">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/nekhpur-logo.png" />
              <button>
                Nekpur website <i class="bi bi-caret-right-fill"></i>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
export default Main;
